import { defineStore } from 'pinia';
import LeadActivitiesAPI from 'dashboard/api/leadActivities';

export const useLeadActivitiesStore = defineStore('leadActivities', {
  state: () => ({
    byLead: {}, // { leadId: [activities] }
    myPending: [],
    loading: false,
  }),
  actions: {
    async fetchForLead(leadId) {
      this.loading = true;
      try {
        const { data } = await LeadActivitiesAPI.index(leadId);
        this.byLead = { ...this.byLead, [leadId]: data };
        return data;
      } finally {
        this.loading = false;
      }
    },
    async create(leadId, payload) {
      const { data } = await LeadActivitiesAPI.create(leadId, payload);
      const list = this.byLead[leadId] || [];
      this.byLead = { ...this.byLead, [leadId]: [...list, data] };
      return data;
    },
    async update(leadId, id, payload) {
      const { data } = await LeadActivitiesAPI.update(leadId, id, payload);
      const list = (this.byLead[leadId] || []).map(a =>
        a.id === id ? data : a
      );
      this.byLead = { ...this.byLead, [leadId]: list };
      return data;
    },
    async complete(leadId, id, outcome, notes) {
      const { data } = await LeadActivitiesAPI.complete(leadId, id, {
        outcome,
        outcome_notes: notes,
      });
      return data;
    },
    async fetchMyPending() {
      const { data } = await LeadActivitiesAPI.myPending();
      this.myPending = data;
      return data;
    },
  },
});
